import {
  GET_OPTIONS_REQUEST,
  GET_OPTIONS_SUCCESS,
  GET_OPTIONS_FAILURE,
} from "actions/option";

const initialState = {
  loading: false,
  dnsp: [],
  retailer: [],
  region: [],
  location: [],
  meter_model: [],
  vpp: [],
  channel: [],
  error: {},
};

export default function option(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_OPTIONS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_OPTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        ...payload,
        lifecycle_state: payload.state.sort((a, b) =>
          a.value === "operational" ? -1 : a.value > b.value ? 1 : -1,
        ),
        meter_model: payload.meter_model.map((it) => {
          return {
            ...it,
            value: it.id,
            label: it.model,
          };
        }),
      };
    }

    case GET_OPTIONS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
}
